<template>
    <div class="page short-video-detail" :style="loading ? 'background:#fff;':''">

        <short-video-detail-skeleton v-if="loading" style="margin-bottom: 100vh;"></short-video-detail-skeleton>

        <video id="my-video" class="video-js vjs-default-skin vjs-big-play-centered" controls preload="none" x5-playsinline="" webkit-playsinline="" playsinline="" :poster="short_video.cover_img" x-webkit-airplay="true"></video>

        <div class="short-video-control">
            <div class="short-video-control-title">{{short_video.title}}</div>
            <van-grid :column-num="5" :border="false" class="short-video-control-box">
                <van-grid-item v-if="short_video.isFavorite" icon="/static/img/video/icon_viedo_lfavorite_on.svg" @click="favorite()">
                    <span slot="text" class="van-grid-item__text isFavorite">{{short_video.favorite_count}}</span>
                </van-grid-item>
                <van-grid-item v-else icon="/static/img/video/icon_viedo_lfavorite_off.svg" @click="favorite()">
                    <span slot="text" class="van-grid-item__text">{{short_video.favorite_count}}</span>
                </van-grid-item>
                <van-grid-item v-if="short_video.isLike" icon="/static/img/video/icon_viedo_like_on.svg" @click="pointLike()">
                    <span slot="text" class="van-grid-item__text isLike">{{short_video.like_count}}</span>
                </van-grid-item>
                <van-grid-item v-else icon="/static/img/video/icon_viedo_like_off.svg" @click="pointLike()">
                    <span slot="text" class="van-grid-item__text">{{short_video.like_count}}</span>
                </van-grid-item>
                <van-grid-item icon="/static/img/video/icon_viedo_watch.svg" >
                    <span slot="text" class="van-grid-item__text">{{short_video.view_count}}</span>
                </van-grid-item>
                <van-grid-item v-if="short_video.comment_count > 0" icon="/static/img/video/icon_viedo_comment.svg" @click="commend_visible = true" text="评论" :badge="short_video.comment_count" />
                <van-grid-item v-else icon="/static/img/video/icon_viedo_comment.svg" @click="commend_visible = true" text="评论" />
                <van-grid-item @click="openShareData" icon="/static/img/video/icon_viedo_share.svg" text="转发" />
            </van-grid>
        </div>

        <van-action-sheet v-model="commend_visible" :title="short_video.comment_count == 0 ? '评论' : short_video.comment_count+'条评论'">
            <div class="short-video-detail-comment">
                <div class="comment">
                    <div class="comment-section" v-for="item in comment" :key="item.id">
                        <div class="comment-section-photo">
                            <img :src="item.avatar" alt="">
                        </div>
                        <div class="comment-section-content">
                            <div class="comment-section-content-author" @click="reComment(item)">
                                {{item.nickname}}
                                <img v-if="item.top == 1" src="/static/third/icon_top.svg" alt="" style="margin-left:4px;margin-bottom:-4px;background: #FDE0BD;border-radius: 4px">
                            </div>
                            <div class="comment-section-content-detail" @click="reComment(item)">{{item.content}}</div>
                            <div class="comment-section-content-bottom">
                                <div class="comment-section-content-time">{{item.created_at}}</div>
                                <div class="comment-section-content-point" @click="pointLikeComment(item)">
                                    <span v-if="item.isLike"><van-icon name="/static/img/course/icon_course_like_on.svg" /></span>
                                    <span v-else><van-icon name="/static/img/course/icon_course_like_off.svg" /></span>
                                    {{item.like_count == 0 ? '赞' : item.like_count}}
                                </div>
                                <div class="clear"></div>
                                <div class="comment-section-content-children" v-if="item.children != null && item.children.length > 0">
                                    <div v-for="val in item.children"> <span @click="reCommentChild(val)">{{val.name}}</span><span style="color: #404040" v-if="val.reply_name != ''"> 回复 </span><span @click="reCommentChild(val)">{{val.reply_name}}</span>：{{val.content}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
            </div>
            <div class="van-action-sheet__footer">
                <div class="short-video-detail-comment-footer">
                    <div class="van-action-sheet__gap "></div>
                    <div class="short-video-detail-comment-footer-left">
                        <van-field round
                                   left-icon="/static/img/course/icon_course_text.svg"
                                   v-model="comment_text"
                                   :placeholder="comment_placeholder">
                        </van-field>
                    </div>
                    <div class="short-video-detail-comment-footer-right">
                        <div class="live-detail-home-footer-right-btn">
                            <van-button type="danger" size="medium" @click="createComment" color="#D3172E">
                                发送
                            </van-button>
                        </div>
                    </div>
                </div>
            </div>
        </van-action-sheet>

        <van-dialog class="share" v-model="showShareDialog" :showConfirmButton="false">
            <img class="share-top-img" src="/static/img/pic_course_share_text.svg" alt="">
            <div class="share-img">
                <img :src="htmlUrl" style="width: 100%" v-if="htmlUrl != ''" alt="">
            </div>
            <div class="share-cancel-btn" @click="showShareDialog = false">
                <img src="/static/img/course/icon_course_share_close.svg" alt="">
            </div>
        </van-dialog>
    </div>
</template>

<script>
    import Interface from "@/util/interface"
    import 'video.js/dist/video-js.css'
    import videojs from 'video.js'
    import shortVideoDetailSkeleton from "@/skeleton/shortVideoDetailSkeleton"
    export default {
        name: 'short-video-detail',
        components :{
            'short-video-detail-skeleton' : shortVideoDetailSkeleton
        },
        data() {
            return {
                short_video: {},
                myPlayer: '',
                cover_img:'',
                commend_visible:false,
                loading:true,
                share_data :{},
                showShareDialog:false,
                htmlUrl:"",
                isShow:false,
                status:"",
                comment_text:"",
                comment:[],
                comment_id :0,
                to_user_id:0,
                comment_placeholder:"写评论",
                user_id:0
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'short-video') {
                    Interface.getData('get', Interface.short_video.detail + '/' + this.id).then((res) => {
                        this.short_video = res.data
                        if(this.short_video){
                            Interface.getShareInfo(this,this.short_video.title,this.short_video.cover_img,"",false)
                        }
                        this.cover_img = res.data.cover_img
                        Interface.getData('get', Interface.video_info + '/' + res.data.video_id).then((resp) => {
                            const videoUrl = resp.data.PlayInfoList.PlayInfo[0].PlayURL
                            const myPlayerOptions = {
                                bigPlayButton: true,
                                textTrackDisplay: true,
                                posterImage: true,
                                errorDisplay: true,
                                controlBar: true,
                                autoplay:false,
                                controls: true,
                            }
                            setTimeout(() => {
                                this.myPlayer = videojs('my-video', myPlayerOptions)
                                this.myPlayer.src(videoUrl)
                                this.myPlayer.load(videoUrl)
                                setTimeout(()=>{
                                    this.loading = false
                                },1000)
                            }, 500)

                        });
                    })
                }else if (scene === 'share') {
                    let params = {
                        content_id : this.id,
                        type:3,
                    }
                    Interface.getData('get', Interface.share,params).then((res) => {
                        this.htmlUrl = res.data.post_img_url
                    })
                }else if (scene === 'comment') {
                    let params = {
                        content_id : this.id,
                        comment_type:3,
                        page:1,
                        pageSize:999
                    }
                    Interface.getData('get', Interface.course.comment.list,params).then((res) => {
                        if(res.code == 0 && res.data.list != null){
                            this.comment = res.data.list
                        }
                    })
                }
            },
            changeCategory() {
                this.fetch('short-video')
            },
            favorite(){
                Interface.getData('get', Interface.short_video.favorite+'/'+this.id).then((res) => {
                    if(res.code == 0){
                        this.short_video.isFavorite = !this.short_video.isFavorite
                        if(this.short_video.isFavorite){
                            this.short_video.favorite_count +=1
                        }else{
                            this.short_video.favorite_count -=1
                        }
                    }
                })
            },
            pointLike(){
                Interface.getData('get', Interface.short_video.point_like+this.id).then((res) => {
                    if(res.code == 0){
                        this.short_video.isLike = !this.short_video.isLike
                        if(this.short_video.isLike){
                            this.short_video.like_count +=1
                        }else{
                            this.short_video.like_count -=1
                        }
                    }
                })
            },
            openShareData(){
                this.showShareDialog = true
            },
            pointLikeComment(item){
                Interface.getData('get', Interface.pointLikeComment+item.id).then((res) => {
                    if(res.code == 0){
                        item.isLike = !item.isLike
                        if (item.isLike){
                            item.like_count += 1
                        }else{
                            item.like_count -= 1
                        }
                    }
                })
            },
            createComment(){
                this.tab = 1
                if (this.comment_text == ""){
                    return;
                }
                if (!Interface.checkComplete(this)){
                    return;
                }
                let params = {
                    content_id:this.id,
                    comment_type:3,
                    content:this.comment_text,
                }
                if(this.comment_id != 0){
                    params.comment_id = +this.comment_id
                }
                if(this.to_user_id != 0){
                    params.to_user_id = +this.to_user_id
                }
                Interface.getData('post', Interface.comment,params).then((res) => {
                    if(res.code == 0){
                        this.$toast.success("评论成功")
                        this.comment_text = ""
                        this.comment_placeholder = "写评论"
                        this.comment_id=0
                        this.to_user_id=0
                        this.fetch('comment')
                        //this.goComment()
                    }
                })
            },
            reComment(item){
                this.comment_placeholder = '回复'+item.nickname
                this.comment_id = item.id
            },
            reCommentChild(item){
                this.comment_placeholder = '回复'+item.nickname
                this.comment_id = item.comment_id
                this.to_user_id = item.user_id
                console.log(item)
            },
        },
        created() {
            this.id = this.$route.params.id
            this.fetch('short-video')
            this.fetch('share')
            this.fetch('comment')
            Interface.footPrint(3,this.id)
        },
        mounted() {
            videojs.addLanguage('zh-CN', {
                "You aborted the media playback": "视频播放被终止",
                "A network error caused the media download to fail part-way.": "网络错误致使视频下载中途失败。",
                "The media could not be loaded, either because the server or network failed or because the format is not supported.": "视频因格式不支持或者服务器或网络的问题没法加载。",
                "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "因为视频文件损坏或是该视频使用了你的浏览器不支持的功能，播放终止。",
                "No compatible source was found for this media.": "没法找到此视频兼容的源。",
            });
        },
        destroyed() {
            if (this.myPlayer){
                this.myPlayer.dispose()
            }
        }
    }
</script>

<style lang="scss">
    @import "./index";
    .content {
        padding: 16px 16px 160px;
    }
</style>



// WEBPACK FOOTER //
// src/views/short-video/detail/index.vue